const processRoutes = [
  {
    path: "/process",
    component: (resolve) =>
      require(["@/views/processManagement/process/index.vue"], resolve),
    meta: {
      title: "task",
      vis: true,
      type: "login",
      alias: "流程管理",
      icon: "el-icon-connection",
    },
    children: [
      {
        path: "/",
        name: "processManagement",
        component: (resolve) =>
          require(["@/views/processManagement/process/list.vue"], resolve),
        meta: {
          title: "process",
          vis: false,
          type: "login",
          alias: "流程管理",
          icon: "el-icon-setting",
        },
      },
      {
        path: "processEditor",
        name: "processEditor",
        component: (resolve) =>
          require([
            "@/views/processManagement/process/processEditor.vue",
          ], resolve),
        meta: {
          title: "process",
          vis: false,
          type: "login",
          alias: "新建流程",
          icon: "el-icon-setting",
        },
      },
      {
        path: "myProcess",
        name: "myProcess",
        component: (resolve) =>
          require(["@/views/processManagement/process/myProcess.vue"], resolve),
        meta: {
          title: "process",
          vis: false,
          type: "login",
          alias: "我的流程",
          icon: "el-icon-setting",
        },
      },
      {
        path: "instance",
        name: "processInstance",
        component: (resolve) =>
          require(["@/views/processManagement/process/instance.vue"], resolve),
        meta: {
          title: "process",
          vis: false,
          type: "login",
          alias: "流程处理",
          icon: "el-icon-setting",
        },
      },
    ],
  },
];

const formRoutes = [
  {
    path: "/formManagement",
    component: (resolve) =>
      require(["@/views/processManagement/form/layout.vue"], resolve),
    meta: {
      title: "formManagement",
      vis: false,
      type: "login",
      alias: "表单管理",
      icon: "el-icon-setting",
    },
    children: [
      {
        path: "/",
        name: "formList",
        component: (resolve) =>
          require(["@/views/processManagement/form/list.vue"], resolve),
        meta: {
          title: "formManagement",
          vis: false,
          type: "login",
          alias: "表单管理",
          icon: "el-icon-setting",
        },
      },
      {
        path: "formEditor",
        name: "createForm",
        component: (resolve) =>
          require(["@/views/processManagement/form/formEditor.vue"], resolve),
        meta: {
          title: "formManagement",
          vis: false,
          type: "login",
          alias: "新建表单",
          icon: "el-icon-setting",
        },
      },
    ],
  },
];

const taskRoutes = [
  {
    path: "/upcomingTasks",
    name: "upcomingTasks",
    component: (resolve) =>
      require(["@/views/processManagement/tasks/upcomingTasks.vue"], resolve),
    meta: {
      title: "upcomingTasks",
      vis: false,
      type: "login",
      alias: "待办任务",
      icon: "el-icon-date",
    },
  },
  {
    path: "/doneTasks",
    name: "doneTasks",
    component: (resolve) =>
      require(["@/views/processManagement/tasks/doneTasks.vue"], resolve),
    meta: {
      title: "doneTasks",
      vis: false,
      type: "login",
      alias: "已办任务",
      icon: "el-icon-date",
    },
  },
];

export default [...processRoutes, ...formRoutes, ...taskRoutes];



// WEBPACK FOOTER //
// ./src/router/routes/process.js